import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axiosInstance from "../../utils/axiosInstance";

export const fetchSeasons = createAsyncThunk(
  "season/fetchSeasons",
  async () => {
    const response = await axiosInstance(
      "/cohorts?include=season,program.capsules,challenges.partner,schools,cohortTargets",
      "get",
    );
    return response.data.data;
  },
);

export const fetchSeasonDetails = createAsyncThunk(
  "season/fetchSeasonDetails",
  async (id) => {
    const response = await axiosInstance(
      `/cohorts/${id}?include=season,program.capsules.modules,partners,schools,cohortTargets,squads.squadUsers.user`,
      "get",
    );
    return response.data.data;
  },
);

export const joinSeason = createAsyncThunk(
  "season/joinSeason",
  async ({ cohortId, squadId, userId }) => {
    await axiosInstance("/squad-users", "post", {
      squad_id: squadId,
      user_id: userId,
    });
    await axiosInstance("/cohort-users", "post", {
      cohort_id: cohortId,
      user_id: userId,
    });
  },
);

const initialState = {
  seasons: [],
  seasonDetails: {},
};

const seasonSlice = createSlice({
  name: "season",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSeasons.fulfilled, (state, action) => {
      state.seasons = action.payload;
    });
    builder.addCase(fetchSeasonDetails.fulfilled, (state, action) => {
      state.seasonDetails = action.payload;
    });
  },
});

export default seasonSlice.reducer;
